export default {
	email: 'email@email.com',
	name: 'Name',
	usertype: 'Username',
	address: 'Address, Street 123',
	dob: '01-01-1970',
	mobile_no: '+91 1234567890',
};
